.container {
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 0;
  align-items: stretch;
  gap: 1.2rem;
  padding: 1.6rem;
  max-width: 100%;
  overflow-x: auto;
}
